import React from "react";
import Drawer from "../../components/Drawer";
import "./webReport.css";

const LeftNavigation = ({
  hasProfileImage,
  metaDataItems,
  issueItems,
  title,
  closeDrawer,
  activeSection,
  foundSubsection,
  foundSection,
  disclaimer,
}) => {
  const toggableLevels = ["sections", "subsections", "issues"];
  return (
    <Drawer
      title={title}
      metaDataContent={metaDataItems}
      hasProfileImage={hasProfileImage}
      issueContent={issueItems}
      toggableLevels={toggableLevels}
      closeDrawer={closeDrawer}
      activeSection={activeSection}
      foundSubsection={foundSubsection}
      foundSection={foundSection}
      disclaimer={disclaimer}
    />
  );
};

export default LeftNavigation;
